<template>
    <el-dialog class="mdialog" custom-class="dialogClass" :append-to-body="true" 
        title="邀请成员加入公司"  :visible.sync="visible"
        :before-close="handleClose">
        <div class="main-container">
            <el-input ref="inviteLink"
                placeholder="邀请链接"
                v-model="inviteLink"
                :disabled="true">
            </el-input>
            <el-button type="primary" @click="handleCopy">复制邀请链接</el-button>
        </div>
        <div class="tips">
            链接有效期至： {{ inviteCanUseDate }}
        </div>
    </el-dialog>
</template>
 
<script>
import iView from 'iview';

import { dateFormat } from '@/tool/transform'
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            inviteLink: '',
            inviteCanUseDate: ''
        }
    },
    methods: {
        handleClose() {
            this.$emit('update:visible', false)
        },
        handleCopy() {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(this.inviteLink)
            } else {
                const testInput = document.createElement('input')
                testInput.value = this.inviteLink
                testInput.style.position = 'absolute'
                testInput.style.opacity = 0
                console.log(testInput)
                document.body.appendChild(testInput)
                testInput.focus()
                testInput.select()
                document.execCommand('copy')
                testInput.remove()
            }
            iView.Notice.success({
                duration: 2,
                desc: '复制成功'
            });
            this.$emit('update:visible', false)
        },
    },
    created() {
        // 从缓存中获取当前有效期起始时间
        // 判断当前时间与邀请链接有效时间是否已过期
        // 有效期为3天
        let inviteStartDate = localStorage.getItem('inviteStartDate') ? new Date(localStorage.getItem('inviteStartDate')) : false
        if (!inviteStartDate) {
            inviteStartDate = new Date()
            localStorage.setItem('inviteStartDate', inviteStartDate.getTime())
        }
        let inviteEndTime = inviteStartDate.setDate(inviteStartDate.getDate() + 3)
        if (inviteEndTime > new Date().getTime()) {
            this.inviteCanUseDate = dateFormat(new Date(inviteEndTime))
        } else {
            inviteStartDate = new Date()
            localStorage.setItem('inviteStartDate', inviteStartDate.getTime())
            inviteEndTime = inviteStartDate.setDate(inviteStartDate.getDate() + 3)
            this.inviteCanUseDate = dateFormat(new Date(inviteEndTime))
        }
        const user = JSON.parse(localStorage.getItem('currentUser')) || {}
        this.inviteLink = `${window.location.origin + window.location.pathname}#/invite-member/index?username=${encodeURIComponent(user.name)}&avatarUrl=${encodeURIComponent(user.avatarUrl)}`
    }
}
</script>
 
<style lang="less" scoped>

/deep/ .dialogClass {
    width: 659px!important;
    @media (max-width: 480px) {
        margin-top: 60%!important;
        width: 90%!important;
    }
}

.main-container {
    display: flex;
}

.tips {
    font-size: 14px;
    font-family: Source Han Sans SC, Source Han Sans SC;
    font-weight: 400;
    color: #999999;
    line-height: 50px;
}

.dialogClass /deep/.el-dialog__header {
    border-bottom: 1px solid #E5E5E5;
    padding: 12px 16px;
}

.dialogClass /deep/ .el-dialog__body.demo-form-inline.el-form-item.el-form-item__content {
    width: 191px;
}

.dialogClass /deep/.el-dialog__body {
    padding: 24px 32px 32px;
}

.dialogClass /deep/.el-dialog__footer {
    border-top: 1px solid #E5E5E5;
    padding: 12px 32px;
}

.dialog-title {
    display: flex;
    align-items: center;
}

.dialogClass/deep/.el-dialog__headerbtn {
    top: 15px;
}

/deep/ .phone input::-webkit-outer-spin-button {
    -webkit-appearance: none;
}
/deep/ .phone input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
/deep/ .phone input[type="number"] {
    -moz-appearance: textfield;
}
</style>


// WEBPACK FOOTER //
// src/zzcbpmDashboard/zhaocha/accountManage/invite/inviteDialog.vue